import { ApolloQueryResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'
import gql from 'graphql-tag'

export interface ValidateResetPasswordLinkTokenQueryObject {
  validateResetPasswordLinkToken: {
    __args: {
      token: string
    }
  }
}

export const validateResetPasswordLinkTokenQueryObject: ValidateResetPasswordLinkTokenQueryObject = {
  validateResetPasswordLinkToken: {
    __args: {
      token: ''
    }
  }
}

interface ValidateResetPasswordLinkTokenQueryInput {
  token: string
}

export type GetValidateResetPasswordLinkTokenQuery = (input: ValidateResetPasswordLinkTokenQueryInput) => Promise<ApolloQueryResult<any>>

export const createValidateResetPasswordLinkToken = ({ getQueries }: ServiceDependencies): GetValidateResetPasswordLinkTokenQuery => async ({ token }) => {
  const query = getQueries().validateResetPasswordLinkTokenQuery
  query.validateResetPasswordLinkToken.__args.token = token

  return apolloClient.query({
    query: gql`{${jsonToGraphQLQuery(query)}}`,
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore'
  })
}
